module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-stevedore-technican/master-stevedore-technican.component.scss
// module id = ./src/app/master/master-stevedore-technican/master-stevedore-technican.component.scss
// module chunks = main